/**
 * @file Segmented 分段控制器
 * @description 基于 antd Segmented 封装，支持 solid（强）/ ghost（弱）两种变体
 */
import {Segmented as AntdSegmented} from 'antd';
import type {SegmentedProps as AntdSegmentedProps} from 'antd';
import {createCx, mergeSemanticClassNames} from '@utils/cx';
import styles from './index.module.less';

const cx = createCx(styles);

export type SegmentedVariant = 'solid' | 'ghost';
export type SegmentedSize = 'large' | 'middle' | 'small';

export interface SegmentedProps extends Omit<AntdSegmentedProps, 'size'> {
    /** 变体：solid（强，选中项高对比反色）| ghost（弱，选中项轻填充）。默认 solid */
    variant?: SegmentedVariant;
    /** 尺寸：large(36px) | middle(32px) | small(28px)。默认 large */
    size?: SegmentedSize;
}

const Segmented: React.FC<SegmentedProps> = ({
    classNames,
    variant = 'solid',
    size = 'large',
    ...restProps
}) => {
    const mergedClassNames = mergeSemanticClassNames({root: cx('root', variant)}, classNames);

    return <AntdSegmented size={size} classNames={mergedClassNames} {...restProps} />;
};

export default Segmented;
